<template>
  <div>
    <b-carousel
      id="product-carousel"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="100%"
      img-height="100%"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        v-if="
          product.imgURLS &&
            Array.isArray(product.imgURLS) &&
            product.imgURLS[0]
        "
        :caption="product.name"
        text=""
        :img-src="product.imgURLS[0].url"
      />
      <b-carousel-slide
        v-else
        caption="Missing Product Image"
        text=""
        img-blank
      />
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "productDetailsImage",
  props: {
    product: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>
